module.exports = __webpack_public_path__ + "static/recipe-collect-thumbnail-d47790c87057964ec0c6c5815e8d6c1a.jpeg";